import PageContainer from '@/components/Container/PageContainer';
import OcCitizenRegistrationForm from '@/components/Pbl/OcCitizenRegistration';
import useResize from '@/hooks/useResize';

import { TitleBar } from '@/components/Pbl/OcCitizenRegistration/styles';
import { useTranslation } from 'react-i18next';

const PblOcCitizenRegistration = () => {
  //   @ts-ignore
  const { t } = useTranslation();
  const { isMobile } = useResize();

  return (
    <PageContainer
      title={
        <TitleBar isMobile={isMobile}>
          <span>
            {t('pbl.pagesHardcoded.ocCitizenRegistration.home')}<strong>{t('pbl.pagesHardcoded.ocCitizenRegistration.authorizationForm')}</strong>
          </span>
        </TitleBar>
      }
    >
      <OcCitizenRegistrationForm />
    </PageContainer>
  );
};

export default PblOcCitizenRegistration;
